import classNames from 'classnames';
import { forwardRef, RefObject } from 'react';
import type { ResizeHandleAxis } from 'react-grid-layout';

import styles from './instrumentPanelResizeHandle.module.scss';

type InstrumentPanelResizeHandleProps = {
  handleAxis?: ResizeHandleAxis;
};

export const InstrumentPanelResizeHandle = forwardRef<
  HTMLElement,
  InstrumentPanelResizeHandleProps
>(function InstrumentPanelResizeHandle(
  { handleAxis, ...props },
  ref,
): JSX.Element {
  return (
    <div
      ref={ref as RefObject<HTMLDivElement>}
      className={classNames(styles.resize, handleAxis && styles[handleAxis])}
      {...props}
    />
  );
});
